/*!
 * Copyright (C) 2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *	2024-05-21 (jhoward)
 *		- Refactor external link warning code from main.js to ExternalLinkWarning.ts.
 */

import siteOptions from "../../../site.options";

$(document)
  .on(
    //@ts-ignore
    'click',
    'a',
    function (this: HTMLAnchorElement, event: MouseEvent) {
      const anchorHostname = (new URL(this.href)).hostname;

      //first, check if the host is the same as the current host
      if (window.location.hostname === anchorHostname && !this.dataset.forceExternal) {
        return;
      }

      //check if the host is one of our websites
      const dialogBody = ((this.dataset.forceExternal || '').toLowerCase() !== 'peppermill' && isExternalHostname(anchorHostname))
        ? siteOptions.externalLinkWarning.externalMessage
        : siteOptions.externalLinkWarning.internalMessage;

      //now we're dealing with links that need to be confirmed
      event.preventDefault();
      event.stopPropagation();

      window.showOverlayDialog({
        confirmAccept: 'CONTINUE',
        confirmTitle: siteOptions.externalLinkWarning.dialogTitle,
        confirmBody: dialogBody,
        callback: 'EXTERNAL-WEBSITE-WARNING'
      }, this);
    });

function isExternalHostname(hostname: string): boolean {
  if (siteOptions.externalLinkWarning.internalHostnames.includes(hostname)) {
    return false;
  } else {
    for (let i = 0, l = siteOptions.externalLinkWarning.internalHostnames.length; i < l; i++) {
      if (
        siteOptions.externalLinkWarning.internalHostnames[i].split('.').length === 2
        && (
          'dev.' + siteOptions.externalLinkWarning.internalHostnames[i] === hostname
          || 'www.' + siteOptions.externalLinkWarning.internalHostnames[i] === hostname
        )
      ) {
        return false;
      }
    }
  }

  return true;
}

$(function () {
  window.ajaxLinkRegisterCallback(
    'EXTERNAL-WEBSITE-WARNING',
    function (this: HTMLAnchorElement) {
      window.hideLoader(true, true)
      const win = window.open(this.href, '_blank');
      if (typeof win === 'undefined' || !win) {
        window.location.href = this.href;
      } else {
        win.focus();
      }
    }
  );
});